export default {
    state: {
        error: false,
        connection: true
    },
    mutations: {
        updateError(state, content) {
            state.error = content;
        },
        updateConnection(state, content) {
            state.connection = content;
        }
    },
    getters: {
        getErrorGlobal(state) {
            return state.error;
        },
        getConnetctionGlobal(state) {
            return state.connection;
        }
    }
};
